__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@wpp-open/core-fe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ebay/nice-modal-react", "1.2.13", () => (Promise.all([__webpack_require__.e(2992), __webpack_require__.e(5362)]).then(() => (() => (__webpack_require__(25362))))));
			register("@platform-ui-kit/components-library-react", "2.21.0", () => (Promise.all([__webpack_require__.e(1226), __webpack_require__.e(2992), __webpack_require__.e(887), __webpack_require__.e(7493)]).then(() => (() => (__webpack_require__(31226))))));
			register("@platform-ui-kit/components-library", "2.21.0", () => (__webpack_require__.e(2682).then(() => (() => (__webpack_require__(2682))))));
			register("@tanstack/react-query", "5.15.0", () => (Promise.all([__webpack_require__.e(4372), __webpack_require__.e(2992)]).then(() => (() => (__webpack_require__(94372))))));
			register("ag-grid-community", "30.2.1", () => (__webpack_require__.e(1731).then(() => (() => (__webpack_require__(81731))))));
			register("ag-grid-react", "30.2.1", () => (Promise.all([__webpack_require__.e(7009), __webpack_require__.e(2992), __webpack_require__.e(887), __webpack_require__.e(3543), __webpack_require__.e(5697)]).then(() => (() => (__webpack_require__(47009))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(3935), __webpack_require__.e(2992)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-use", "17.4.2", () => (Promise.all([__webpack_require__.e(2867), __webpack_require__.e(2992), __webpack_require__.e(7582)]).then(() => (() => (__webpack_require__(22867))))));
			register("react", "18.2.0", () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(67294))))));
			initExternal(64921);
			initExternal(90767);
			initExternal(59395);
			initExternal(44324);
			initExternal(90140);
			initExternal(18081);
			initExternal(76800);
			initExternal(38960);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};